export const authErrors = {
  noArtistId: "auth/no-artist-id",
};
